var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAdgangsplatform = function SvgAdgangsplatform(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 23"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#adgangsplatform_svg__a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "adgangsplatform_svg__b",
    width: 20,
    height: 23,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M9.987 22.963h.026a.4.4 0 0 0 .18-.048l.019-.008 9.576-5.53a.42.42 0 0 0 .212-.366V5.953a.43.43 0 0 0-.212-.368L10.212.057a.43.43 0 0 0-.424 0L.212 5.585A.42.42 0 0 0 0 5.953V17.01c0 .15.08.29.212.366l9.576 5.53.018.01a.4.4 0 0 0 .18.046m.437-21.806 8.305 4.796L10 10.993l-8.729-5.04 8.305-4.796v5.774a.424.424 0 0 0 .848 0zm3.338 12.733a.424.424 0 0 0 .155.579l4.806 2.545-8.3 4.792v-10.08l8.73-5.04v9.597l-4.812-2.549a.423.423 0 0 0-.579.156m-8.036-.2L.847 16.273V6.686l8.729 5.04v10.08l-8.308-4.797 4.881-2.585a.424.424 0 0 0-.423-.734"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#adgangsplatform_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M20 22.963H0V0h20z",
    clipRule: "evenodd"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "adgangsplatform_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M20 0H0v22.963h20z"
  })))));
};
export default SvgAdgangsplatform;